import { render } from "./TemplateScene.vue?vue&type=template&id=14c17e15&scoped=true"
import script from "./TemplateScene.vue?vue&type=script&lang=js"
export * from "./TemplateScene.vue?vue&type=script&lang=js"

import "./TemplateScene.vue?vue&type=style&index=0&id=14c17e15&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-14c17e15"]])

export default __exports__